import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerContact } from "../entities/customer-contact.entity";
import { sortContactsByName } from "../utils/customer-contact.utils";
import { initialCustomersState } from "./customers.state";

const customersSlice = createSlice({
  name: "customers",
  initialState: initialCustomersState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setSaving: (state, { payload }: PayloadAction<boolean>) => {
      state.saving = payload;
    },
    setError: (state, { payload }: PayloadAction<string | null>) => {
      state.error = payload;
    },
    setContacts: (state, { payload }: PayloadAction<CustomerContact[]>) => {
      state.contacts = sortContactsByName(payload);
      state.loading = false;
      state.error = null;
    },
    upsertContact: (state, { payload }: PayloadAction<CustomerContact>) => {
      const index = state.contacts.findIndex(
        (contact) => contact.id === payload.id
      );
      if (index >= 0) {
        state.contacts[index] = payload;
      } else {
        state.contacts.push(payload);
      }
      state.contacts = sortContactsByName(state.contacts);
    },
    setIsEditing: (state, { payload }: PayloadAction<boolean>) => {
      state.isEditing = payload;
      if (!payload) {
        state.selectedIds = [];
      }
    },
    setSelectedIds: (state, { payload }: PayloadAction<number[]>) => {
      state.selectedIds = payload;
    },
    toggleSelectedId: (state, { payload }: PayloadAction<number>) => {
      if (state.selectedIds.includes(payload)) {
        state.selectedIds = state.selectedIds.filter((id) => id !== payload);
      } else {
        state.selectedIds.push(payload);
      }
    },
    hideAlert: (state) => {
      state.showAlert = false;
    },
    setShowDeleteConfirmation: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showDeleteConfirmation = payload;
    },
    resetEditState: (state) => {
      state.isEditing = false;
      state.selectedIds = [];
      state.showDeleteConfirmation = false;
    },
  },
});

export const customersActions = customersSlice.actions;
export const customersReducer = customersSlice.reducer;
